import { takeLatest, put } from "redux-saga/effects";
import { ApiCall } from "../api";
import {
  ELE_SOLICITAR_START,
  ELE_GETLISTADO_COMPLETE,
  ELE_GETLISTADO_START,
  ELE_GETELEMENTOS_COMPLETE,
  NOT_LOADING_COMPLETE,
  NSB_MENSAJE_ADD,
  ELE_RECIBIR_START,
} from "../../const/actionTypes";
// import { addMinutes } from "date-fns";
import { jwtDecode } from "jwt-decode";

export function* GetElementos({ payload }) {
  const p = {
    ...payload,
  };
  const token = {
    ...jwtDecode(p.Token),
  };
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
  ) {
    yield put({ type: NOT_LOADING_COMPLETE, payload: true });
    const ele = yield ApiCall(
      "/api/Elementos/ObtenerElementos",
      "POST",
      JSON.stringify({}),
      p.Token
    );
    if (ele)
      yield put({ type: ELE_GETELEMENTOS_COMPLETE, payload: ele.Results });
    const sol = yield ApiCall(
      "/api/Elementos/ObtenerSolicitudes",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    if (sol)
      yield put({
        type: ELE_GETLISTADO_COMPLETE,
        payload: sol.Results,
      });

    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
  }
}
export function* Solicitar({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });
  const p = {
    ...payload,
  };
  const token = {
    ...jwtDecode(p.Token),
  };
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
  ) {
    const res = yield ApiCall(
      "/api/Elementos/Solicitar",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    let mensaje;
    if (res && !res.Error) {
      mensaje = {
        mensaje: "Solicitud realizada con éxito.",
        variant: "success",
      };
      yield GetElementos({
        payload: { Conductor: p.Conductor, Token: p.Token },
      });
    } else {
      mensaje = {
        mensaje:
          "Hubo un error al realizar la solicitud.\nIntente nuevamente mas tarde.",
        variant: "error",
      };
    }
    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
    yield put({ type: NSB_MENSAJE_ADD, payload: mensaje });
  }
}
export function* Recibir({ payload }) {
  yield put({ type: NOT_LOADING_COMPLETE, payload: true });
  const p = { ...payload };
  const token = {
    ...jwtDecode(p.Token),
    // opcion: "elementos/recibir",
    // browser: JSON.stringify(window.navigator.userAgent),
    // conductorsol: p.Conductor,
  };
  // yield ApiCall("/api/Log/GrabarLog", "POST", JSON.stringify(token), p.Token);
  // let nbf = null;
  // try {
  //   nbf = new Date(token.nbf * 1000);
  // } catch {}
  if (
    token &&
    token.conductor &&
    token.conductor.toString() === p.Conductor.toString()
    // &&    (!nbf || (nbf && nbf >= addMinutes(new Date(), -3)))
  ) {
    const res = yield ApiCall(
      "/api/Elementos/Recibir",
      "POST",
      JSON.stringify(p),
      p.Token
    );
    if (res && !res.Error) {
      yield GetElementos({
        payload: { Conductor: p.Conductor, Token: p.Token },
      });
    }
    yield put({ type: NOT_LOADING_COMPLETE, payload: false });
  }
}
export default function* elementos() {
  yield takeLatest(ELE_GETLISTADO_START, GetElementos);
  yield takeLatest(ELE_SOLICITAR_START, Solicitar);
  yield takeLatest(ELE_RECIBIR_START, Recibir);
}
